import React, { createContext, useContext, useState, useEffect } from 'react';
import { authStateListener } from '../supabase/auth';
import { getUserProfile } from '../supabase/database';

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = authStateListener(async (userAuth) => {
      if (userAuth) {
        try {
          // Supabase menggunakan id, tapi kita tetap support uid untuk kompatibilitas
          const userId = userAuth.id || userAuth.uid;
          console.log('🔍 AuthContext: Loading profile for userId:', userId);
          const userProfile = await getUserProfile(userId);
          
          console.log('👤 AuthContext: Profile loaded:', userProfile);
          if (userProfile) {
            setCurrentUser({ ...userAuth, ...userProfile });
          } else {
            console.warn('⚠️ AuthContext: No profile found, using fallback');
            // Fallback: create a basic user object if profile fails
            // Try to determine role from email (temporary workaround)
            const role = userAuth.email?.includes('admin') ? 'admin' : 'mitra';
            setCurrentUser({ ...userAuth, role, email: userAuth.email });
          }
        } catch (error) {
          console.error('❌ AuthContext: Error loading profile:', error);
          // Fallback: use auth data with assumed role
          const role = userAuth.email?.includes('admin') ? 'admin' : 'mitra';
          setCurrentUser({ ...userAuth, role, email: userAuth.email });
        }
      } else {
        setCurrentUser(null);
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const value = { currentUser, loading };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};